<template>
  <single-file-uploader :upload-url="socialIdUploadUrl"
                        class="uploader"
                        field-name="file"
                        :input-id="partName"
                        :preloaded-file="partFileVersion"
                        :preload-success-text="preloadSuccessText"
                        :validated-value="partFileVersion"
                        :validations="`socialIdValidation:${partValidationErrorMessage}`"
                        :accept="{ mimeType: 'image/*', disclaimer: 'אפשר להעלות רק קבצים מסוג Jpeg או Png'}"
                        @observe="observe"
                        @uploaded="({ fileVersion }) => socialIdPartUploaded(partName, fileVersion)"
                        @removed="socialIdPartRemove(partName)" />
</template>

<script>
import SingleFileUploader from '@/components/SingleFileUploader';
import ValidationObserver from '@/mixins/ValidationObserver';

export default {
  name: 'SocialIdPartUploader',
  components: { SingleFileUploader },
  mixins: [ValidationObserver],
  props: {
    socialIdUploadUrl: {
      type: String,
      required: true,
    },
    partName: {
      type: String,
      required: true,
    },
    partNameHebrew: {
      type: String,
      required: true,
    },
    socialIdFiles: Object,
    preloadSuccessText: {
      type: String,
      required: true,
    },
  },
  computed: {
    partValidationErrorMessage() {
      return `אי אפשר להמשיך בלי להעלות ${this.partNameHebrew}`;
    },
    partFileVersion() {
      return this.socialIdFiles && this.socialIdFiles[this.partName];
    },
  },
  methods: {
    socialIdPartUploaded(partName, fileVersion) {
      this.$emit('uploaded', { partName, fileVersion });
    },
    socialIdPartRemove(partName) {
      this.$emit('removed', { partName });
    },
  },

};
</script>
